"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GlobalStyles = void 0;

var _react = _interopRequireDefault(require("react"));

var _styletronEngineAtomic = require("styletron-engine-atomic");

var _styletronReact = require("styletron-react");

var _baseui = require("baseui");

var _propTypes = require("prop-types");

var _nextMovieTheme = require("./next-movie-theme");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var engine = new _styletronEngineAtomic.Client();

var GlobalStyles = function GlobalStyles(_ref) {
  var children = _ref.children;
  return _react["default"].createElement(_styletronReact.Provider, {
    value: engine
  }, _react["default"].createElement(_baseui.BaseProvider, {
    theme: _nextMovieTheme.NextMovieTheme
  }, children));
};

exports.GlobalStyles = GlobalStyles;
GlobalStyles.propTypes = {
  children: _propTypes.node.isRequired
};